import {
  BuilderSelection,
  BuilderSelectionProps,
} from "@hub/ui/builder/builder-selection";
import React from "react";
import styles from "./builder-selections.module.css";

interface BuilderSelectionsProps {
  selections: BuilderSelectionProps[];
}

export const BuilderSelections: React.FC<BuilderSelectionsProps> = ({
  selections,
}) => {
  return (
    <div className={styles.builderSelections}>
      {selections.map((selection) => (
        <BuilderSelection
          key={selection.title}
          {...selection}
          stepNumber={selection.stepNumber}
        />
      ))}
    </div>
  );
};
